import { i18n } from "../../i18n-config";

const DEFAULT_LOCALE = i18n.defaultLocale;
const LOCALES = new Set(i18n.locales);

export const ROUTE_ALIASES = {
  "": {
    en: "",
    tr: "",
  },
  platform: { en: "platform", tr: "platform" },
  "platform/chat-assistant": {en:"platform/chat-assistant",tr:"platform/yazili-asistan"},
  "platform/automation": {en:"platform/automation",tr:"platform/isleri-otomatiklestirme"},
  "platform/live-support": {en:"platform/live-support",tr:"platform/canli-destek"},
  "platform/voice-ai": { en: "platform/voice-ai", tr: "platform/sesli-asistan" },
  about: {
    en: "about",
    tr: "hakkimizda",
  },
  announcements: {
    en: "announcements",
    tr: "duyurular",
  },
  "become-a-partner": {
    en: "partner-program",
    tr: "is-ortagi-ol",
  },
  "become-a-tech-partner": {
    en: "tech-partner-program",
    tr: "teknoloji-ortagi-ol",
  },
  blog: {
    en: "blog",
    tr: "blog",
  },
  career: {
    en: "careers",
    tr: "kariyer",
  },
  chatbot: {
    en: "ai-chatbot",
    tr: "yapay-zeka-chatbot",
  },
  ebooks: {
    en: "ebooks",
    tr: "e-kitaplar",
  },
  "google-maps": {
    en: "google-maps-integration",
    tr: "google-haritalar-entegrasyonu",
  },
  instagram: {
    en: "instagram-chatbot",
    tr: "instagram-chatbot",
  },
  "help-center": {
    en: "help-center",
    tr: "yardim-merkezi",
  },
  "help-center/basics": {
    en: "help-center/basics",
    tr: "yardim-merkezi/temeller",
  },
  "help-center/resources": {
    en: "help-center/resources",
    tr: "yardim-merkezi/kaynaklar",
  },
  "help-center/ai-agent": {
    en: "help-center/ai-agent",
    tr: "yardim-merkezi/ai-ajani",
  },
  "help-center/setup": {
    en: "help-center/setup",
    tr: "yardim-merkezi/kurulum",
  },
  "help-center/integrations": {
    en: "help-center/integrations",
    tr: "yardim-merkezi/entegrasyonlar",
  },
  "help-center/reporting": {
    en: "help-center/reporting",
    tr: "yardim-merkezi/raporlama",
  },
  integrations: {
    en: "integrations",
    tr: "entegrasyonlar",
  },
  "integrations/shopify": {
    en: "shopify-integration",
    tr: "shopify-entegrasyonu",
  },
  "integrations/facebook": {
    en: "facebook-chatbot",
    tr: "facebook-chatbot",
  },
  "integrations/hepsiburada": {
    en: "hepsiburada-integration",
    tr: "hepsiburada-entegrasyonu",
  },
  "integrations/ikas": {
    en: "ikas-integration",
    tr: "ikas-entegrasyonu",
  },
  "integrations/instagram": {
    en: "instagram-integration",
    tr: "instagram-entegrasyonu",
  },
  "integrations/tsoft": {
    en: "tsoft-integration",
    tr: "tsoft-entegrasyonu",
  },
  "integrations/whatsapp": {
    en: "whatsapp-chatbot",
    tr: "whatsapp-chatbot",
  },
  // TODO: Re-enable when Trendyol legal issue is resolved.
  // "integrations/trendyol": {
  //   en: "trendyol-integration",
  //   tr: "trendyol-entegrasyonu",
  // },
  // TODO: Re-enable Amazon integration alias when the page is ready.
  // "integrations/amazon": {
  //   en: "amazon-integration",
  //   tr: "amazon-entegrasyonu",
  // },
  "keep-in-touch": {
    en: "contact",
    tr: "iletisim",
  },
  "live-chat-ticket": {
    en: "customer-service-chatbot-software",
    tr: "musteri-hizmetleri-chatbot-yazilimi",
  },
  pricing: {
    en: "pricing",
    tr: "fiyatlandirma",
  },
  "whatsapp-export-privacy": { en: "whatsapp-export-privacy", tr: "whatsapp-export-privacy" },
  "whatsapp-marketing": { en: "whatsapp-marketing", tr: "whatsapp-pazarlama" },
  "company-information": { en: "company-information", tr: "sirket-bilgileri" },
  "delivery-and-returns": { en: "delivery-and-returns", tr: "teslimat-ve-iade" },
  "distance-sales-agreement": { en: "distance-sales-agreement", tr: "mesafeli-satis-sozlesmesi" },
  "privacy-policy": {
    en: "privacy-policy",
    tr: "gizlilik-politikasi",
  },
  "success-stories": {
    en: "success-stories",
    tr: "basari-hikayeleri",
  },
  "solutions/customer-support": {
    en: "ai-customer-support",
    tr: "yapay-zeka-musteri-hizmetleri",
  },
  solutions: {
    en: "solutions",
    tr: "cozumler",
  },
  "solutions/sales": {
    en: "sales-chatbot",
    tr: "satis-chatbot",
  },
  "solutions/marketing": {
    en: "marketing-chatbot",
    tr: "pazarlama-chatbot",
  },
  "solutions/e-commerce": {
    en: "ecommerce-chatbot",
    tr: "e-ticaret-chatbot",
  },
  "solutions/travel": { en: "travel-ai-assistant", tr: "seyahat-yapay-zeka-asistani" },
  "solutions/hospitality": {
    en: "hospitality-ai-assistant",
    tr: "otelcilik-yapay-zeka-asistani",
  },
  "solutions/government": {
    en: "government-ai-assistant",
    tr: "kamu-yapay-zeka-asistani",
  },
};

export const QUERY_ALIASES = {
  en: {
    "ecommerce-chatbot-integrations": {
      path: "integrations",
      query: { category: "ecommerce" },
    },
  },
  tr: {
    "e-ticaret-chatbot-entegrasyonu": {
      path: "integrations",
      query: { category: "ecommerce" },
    },
  },
};

const normalizePath = (value) => {
  if (!value) return "";
  const raw = String(value).trim();
  if (!raw) return "";
  const base = raw.split(/[?#]/)[0];
  return base.replace(/^\/+|\/+$/g, "");
};

export const normalizeLocale = (locale) => (LOCALES.has(locale) ? locale : DEFAULT_LOCALE);

export const normalizePathname = (pathname) => {
  if (!pathname) return "/";
  const raw = String(pathname).trim();
  if (!raw) return "/";
  const base = raw.split(/[?#]/)[0];
  const trimmed = base.replace(/^\/+|\/+$/g, "");
  return trimmed ? `/${trimmed}` : "/";
};

export const splitLocaleFromPathname = (pathname) => {
  const normalized = normalizePathname(pathname);
  const segments = normalized.split("/").filter(Boolean);
  const maybeLocale = segments[0];
  const locale = LOCALES.has(maybeLocale) ? maybeLocale : null;
  const remainder = locale ? `/${segments.slice(1).join("/")}` : normalized;
  return { locale, pathname: normalizePathname(remainder) };
};

const toSearchParams = (input) => {
  if (!input) return new URLSearchParams();
  if (input instanceof URLSearchParams) return new URLSearchParams(input.toString());
  if (typeof input === "string") {
    const raw = input.startsWith("?") ? input.slice(1) : input;
    return new URLSearchParams(raw);
  }
  const params = new URLSearchParams();
  Object.entries(input).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });
  return params;
};

const isExactQueryMatch = (params, expected) => {
  if (!expected) return false;
  const expectedKeys = Object.keys(expected);
  if (params.size !== expectedKeys.length) return false;
  return expectedKeys.every((key) => params.get(key) === String(expected[key]));
};

const buildAliasIndex = () => {
  const index = {};
  i18n.locales.forEach((locale) => {
    index[locale] = new Map();
  });

  Object.entries(ROUTE_ALIASES).forEach(([internalPath, aliases]) => {
    i18n.locales.forEach((locale) => {
      const alias = aliases?.[locale];
      if (alias === undefined) return;
      index[locale].set(normalizePath(alias), internalPath);
    });
  });

  return index;
};

const ALIAS_INDEX = buildAliasIndex();

export const findInternalPathByAlias = (aliasPath) => {
  const normalizedAlias = normalizePath(aliasPath);
  if (!normalizedAlias) return { path: "", query: null };

  for (const locale of i18n.locales) {
    const queryAliases = QUERY_ALIASES[locale] || {};
    const queryTarget = queryAliases[normalizedAlias];
    if (queryTarget) {
      return { path: normalizePath(queryTarget.path), query: queryTarget.query };
    }

    const index = ALIAS_INDEX[locale];
    if (index?.has(normalizedAlias)) {
      return { path: index.get(normalizedAlias), query: null };
    }

    const segments = normalizedAlias.split("/");
    for (let i = segments.length; i > 0; i -= 1) {
      const prefix = segments.slice(0, i).join("/");
      const internalBase = index?.get(prefix);
      if (internalBase) {
        const rest = segments.slice(i).join("/");
        return { path: rest ? `${internalBase}/${rest}` : internalBase, query: null };
      }
    }
  }

  return null;
};

export const resolveInternalPath = (locale, aliasPath) => {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedAlias = normalizePath(aliasPath);
  const queryAliases = QUERY_ALIASES[normalizedLocale] || {};
  const queryTarget = queryAliases[normalizedAlias];

  if (queryTarget) {
    return { path: normalizePath(queryTarget.path), query: queryTarget.query };
  }

  const index = ALIAS_INDEX[normalizedLocale];
  if (index?.has(normalizedAlias)) {
    return { path: index.get(normalizedAlias), query: null };
  }

  if (normalizedAlias) {
    const segments = normalizedAlias.split("/");
    for (let i = segments.length; i > 0; i -= 1) {
      const prefix = segments.slice(0, i).join("/");
      const internalBase = index?.get(prefix);
      if (internalBase) {
        const rest = segments.slice(i).join("/");
        return { path: rest ? `${internalBase}/${rest}` : internalBase, query: null };
      }
    }
  }

  return { path: normalizedAlias, query: null };
};

export const resolveAliasForInternalPath = (locale, internalPath, searchParams) => {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedInternal = normalizePath(internalPath);
  const params = toSearchParams(searchParams);
  const queryAliases = QUERY_ALIASES[normalizedLocale] || {};
  const matchedQueryAlias = Object.entries(queryAliases).find(
    ([, target]) => target.path === normalizedInternal && isExactQueryMatch(params, target.query)
  );

  if (matchedQueryAlias) {
    return { aliasPath: normalizePath(matchedQueryAlias[0]), handledQuery: true };
  }

  const entry = ROUTE_ALIASES[normalizedInternal];
  const alias = entry?.[normalizedLocale];
  if (alias !== undefined) {
    return { aliasPath: normalizePath(alias), handledQuery: false };
  }

  if (normalizedInternal) {
    const segments = normalizedInternal.split("/");
    for (let i = segments.length; i > 0; i -= 1) {
      const prefix = segments.slice(0, i).join("/");
      const prefixEntry = ROUTE_ALIASES[prefix];
      const aliasPrefix = prefixEntry?.[normalizedLocale];
      if (aliasPrefix !== undefined) {
        const rest = segments.slice(i).join("/");
        const aliasPath = [normalizePath(aliasPrefix), rest].filter(Boolean).join("/");
        return { aliasPath, handledQuery: false };
      }
    }
  }

  return { aliasPath: normalizedInternal, handledQuery: false };
};

export const buildPublicPathname = (locale, aliasPath) => {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedAlias = normalizePath(aliasPath);
  const suffix = normalizedAlias ? `/${normalizedAlias}` : "";
  if (normalizedLocale === DEFAULT_LOCALE) {
    return suffix || "/";
  }
  return `/${normalizedLocale}${suffix}`;
};

export const buildLocalizedHref = (locale, internalPath, searchParams) => {
  const params = toSearchParams(searchParams);
  const { aliasPath, handledQuery } = resolveAliasForInternalPath(locale, internalPath, params);
  const pathname = buildPublicPathname(locale, aliasPath);
  if (handledQuery || params.size === 0) return pathname;
  const queryString = params.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
};

export const buildLocalizedUrl = (baseUrl, locale, internalPath, searchParams) => {
  const base = String(baseUrl || "").replace(/\/$/, "");
  const href = buildLocalizedHref(locale, internalPath, searchParams);
  if (!base) return href;
  return href === "/" ? base : `${base}${href}`;
};


